import axios from "axios";

const wtyReportAxios = axios.create({
    baseURL: process.env.REACT_APP_WTY_REPORT_SERVICE_URL,
    // timeout: 60000,
    headers: {
        "Content-Type": "application/json"
    }
});

const wtyReportApi = {
    get: (url, params, headers = {}) => {
        const oktaTokenStorage = JSON.parse(sessionStorage.getItem("okta-token-storage"));
        const accessToken = oktaTokenStorage?.accessToken.accessToken;
        wtyReportAxios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
        return wtyReportAxios.get(url, {params, headers});
    },
    post: (url, data, headers = {}, queryParams = {}) => {
        const oktaTokenStorage = JSON.parse(sessionStorage.getItem("okta-token-storage"));
        const accessToken = oktaTokenStorage?.accessToken.accessToken;

        // Append query parameters to the URL
        const queryString = Object.keys(queryParams)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
            .join('&');

        const fullUrl = queryString ? `${url}?${queryString}` : url;

        wtyReportAxios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

        return wtyReportAxios.post(fullUrl, data, {headers});
    }
};

export default wtyReportApi;